export const boundsToPolygon = bounds => {
  const { north, east, west, south } = bounds;
  const path = [
    [west, north],
    [east, north],
    [east, south],
    [west, south],
    [west, north]
  ];
  return {
    type: "Polygon",
    coordinates: [path]
  };
};

// assuming the polygon is obtaned by above converter function.
export const polygonToGoogleMapBounds = polygon => {
  // assuming not multi polygon with whole or anything
  const path = polygon.coordinates[0];
  const [north, south] = path.reduce(
    (val, elem) => [Math.max(elem[1], val[0]), Math.min(elem[1], val[1])],
    [path[0][1], path[0][1]]
  );
  const [east, west] = path.reduce(
    (val, elem) => [Math.max(elem[0], val[0]), Math.min(elem[0], val[1])],
    [path[0][0], path[0][0]]
  );

  return {
    north,
    east,
    west,
    south
  };
};
